/** @format */

import React from 'react';
import Text from 'components/ui/Text';
import { Row, Column } from 'components/ui/Grid';
import AnchorLink from 'components/ui/AnchorLink';
import { colors } from 'theme';
import styled from 'styled-components';
import media from 'utils/media-queries';
import { BackgroundTitle, bgTitleSizes } from 'components/ui2/BackgroundTitle';

const MyRow = styled(Row)`
margin-top: 6em;

${media.md`
  margin-top: 0;
`};

`;

const orariSettimanali = [
  {
    dayName: 'Lunedì',
    values: [{
      from: '8',
      to: '18',
    }],
  },
  {
    dayName: 'Martedi',
    values: [{
      from: '8',
      to: '18',
    }],
  },
  {
    dayName: 'Mercoledì',
    values: [{
      from: '8',
      to: '18',
    }],
  },
  {
    dayName: 'Giovedì',
    values: [{
      from: '8',
      to: '18',
    }],
  },
  {
    dayName: 'Venerdì',
    values: [{
      from: '8',
      to: '18',
    }],
  },
  {
    dayName: 'Sabato',
    values: [{
      from: '8',
      to: '18',
    }],
  },
];

const orariSettimanaliIncontri = [
  {
    dayName: 'Lunedì',
    values: [{
      from: '9',
      to: '13',
    }],
  },
  {
    dayName: 'Martedi',
    values: [{
      from: '9',
      to: '13',
    }],
  },
  {
    dayName: 'Mercoledì',
    values: [{
      from: '9',
      to: '13',
    }],
  },
  {
    dayName: 'Giovedì',
    values: [{
      from: '9',
      to: '13',
    }],
  },
  {
    dayName: 'Venerdì',
    values: [{
      from: '9',
      to: '13',
    }],
  },
];

const ComeContattarci = ({ color }) => (
  <MyRow>
    <BackgroundTitle
      size={bgTitleSizes.small}
      label="COME CONTATTARCI"
      bgColor={color}
    />
    <Row fluid margin="2em 0 2.5em">
      <Text
        value="Hai bisogno di maggiori informazioni o desideri comunicare direttamente con un operatore WeMi?"
      />
    </Row>
    <Row fluid padding="0 0 .5em">
      <Text
        transform="uppercase"
        letterSpacing="0.05em"
        color="darkGrey"
        value="CHIAMACI"
      />
    </Row>
    <Row fluid padding="0 0 .5em">
      <AnchorLink
        weight="bold"
        color={color}
        textDecoration="none"
        value="020202"
        to="tel:02 02 02"
      />
        &nbsp;
      <Text
        value="- tasto 4.1.3"
        weight="bold"
        color={color}
      />
    </Row>
    <Row fluid padding="0 0 .5em">
      <Text
        value="nei seguenti orari:"
      />
    </Row>
    {orariSettimanali.map((el, i) => (
      <Row fluid key={`key-${i}-${el.dayName}`} padding="0">
        <Column xs="4" padding="0">
          <Text
            value={el.dayName}
          />
        </Column>
        <Column xs="8" padding="0">
          {el.values.map((hours, i) => (
            <Row fluid key={`key-${i}`}>
              <Text
                value={`dalle ${hours.from} alle ${hours.to}`}
              />
            </Row>
            ))}
        </Column>
      </Row>
      ))}
    <Row fluid padding="2.5em 0 .5em">
      <Text
        transform="uppercase"
        letterSpacing="0.05em"
        value="scrivici"
      />
    </Row>
    <Row fluid padding="0 0 .5em">
      <AnchorLink
        weight="bold"
        color={color}
        value="Invia la tua richiesta online"
        to="https://servizicrm.comune.milano.it/spec/servizisociali/sportelloassistentifamiliari"
        textDecoration="none"
      />
      <div>
        oppure scrivi a&nbsp;
        <a
          href="mailto:wemi.tatecolfbadanti@comune.milano.it"
          style={{ color: colors[color], fontWeight: 'bold' }}
        >
          wemi.tatecolfbadanti@
          <wbr />
          comune.milano.it
        </a>
      </div>
    </Row>
    <Row fluid padding="2.5em 0 .5em">
      <Text
        transform="uppercase"
        letterSpacing="0.05em"
        value="incontraci"
      />
    </Row>
    <Row fluid padding="0">
      <Text
        weight="bold"
        color={color}
        value="Sportello assistenti Familiari"
      />
    </Row>
    <Row fluid padding="0">
      <Text
        value="Corso di Porta Vigentina, 15"
      />
    </Row>
    <Row fluid padding="0">
      <Text
        value="20121 Milano"
      />
    </Row>
    <Row fluid padding="0">
      <Text
        value="M3 Crocetta"
      />
    </Row>
    <Row fluid padding="2.5em 0 .5em">
      <Text
        transform="uppercase"
        letterSpacing="0.05em"
        value="orari"
      />
    </Row>
    <Row fluid padding="0">
      <Text
        value="Lunedì - venerdì dalle 9 alle 13 con appuntamento"
      />
    </Row>

    {/* <Row fluid padding="0 0 .5em">
      <Text
        value="nei seguenti orari previo appuntamento:"
      />
    </Row> */}
    {/* {orariSettimanaliIncontri.map((el, i) => (
      <Row fluid key={`key-${i}-${el.dayName}-incontri`} padding="0">
        <Column xs="4" padding="0">
          <Text
            value={el.dayName}
          />
        </Column>
        <Column xs="8" padding="0">
          {el.values.map((hours, i) => (
            <Row fluid key={`key-${i}-incontri`}>
              <Text
                value={`dalle ${hours.from} alle ${hours.to}`}
              />
            </Row>
            ))}
        </Column>
      </Row>
      ))} */}
  </MyRow>
  );

ComeContattarci.displayName = 'ComeContattarci';
export default ComeContattarci;
